import { Button } from 'modules';
import { useGetMyReferralListExportQuery } from 'services/auth/queries/useGetMyReferralListExportQuery';
import toast from 'react-hot-toast';
import { isRequestError } from 'utils/requestError';
import { saveListExcel } from 'utils/tableExport/saveListExcel';
import { ColumnDef } from '@tanstack/react-table';
import { PopupWraper, TableListData } from 'components';
import React, { useEffect, useState } from 'react';
import { useGetMyReferraQuery } from 'services';
import { GetMyRefferals } from 'services/openapi';
import { columnsDefined } from './config';

type Props = {
  isOpen: boolean;
  isLoadingProcess?: boolean;
  onSuccess?: ({ refferalCode }: { refferalCode: string }) => void;
  onClose?: () => void;
};

const ModalMyRefferal = (props: Props) => {
  const { isOpen, onClose } = props;

  const [isShowPopup, setIsShowPopup] = useState<boolean>(isOpen);

  useEffect(() => {
    setIsShowPopup(isOpen);
  }, [isOpen]);

  const { isFetching: isLoadingExport, refetch: refetchExport } =
    useGetMyReferralListExportQuery({});

  const handleExportExcel = async () => {
    if (isLoadingExport) return;
    try {
      const result = await refetchExport({ throwOnError: true });
      await saveListExcel(
        result.data?.data,
        columnsDefined as ColumnDef<GetMyRefferals>[],
        'Danh_sach_nguoi_duoc_gioi_thieu',
        false,
      );
    } catch (error) {
      if (!isRequestError(error)) {
        toast.error(
          error instanceof Error ? error.message : 'Không thể tải danh sách',
        );
      }
    }
  };

  if (!isShowPopup) return <></>;

  return (
    <PopupWraper
      center
      title='Danh sách Người dùng được giới thiệu'
      onClose={() => {
        setIsShowPopup(false);
        onClose && onClose();
      }}
    >
      <div className='textCenter mt16 mb20 wrapButtonFilter'>
        <Button
          className='ml15'
          onClick={handleExportExcel}
          label={'Tải về DS'}
          type='button'
          buttonType='info'
          isLoading={isLoadingExport}
        />
      </div>
      <TableListData<GetMyRefferals>
        columns={columnsDefined as ColumnDef<GetMyRefferals>[]}
        useQuery={useGetMyReferraQuery}
      />
    </PopupWraper>
  );
};

export default ModalMyRefferal;
